export default class Authorization {
  static get ROLES() {
    return {
      allow: 'BWL-gasmonitoring.ALLOW',
      user: 'BWL-gasmonitoring.USER',
      admin: 'BWL-gasmonitoring.ADMIN'
    }
  }

  static VIEWS() {
    return {
      notAuthorized: 'NotAuthorized'
    }
  }


}
